import { ActionPicker as SharedActionPicker } from "@/components/ActionPicker";

import { useToolActionCatalog } from "../../api/hooks";
import type { PickerAction } from "../../types";

/** Tool admin picker (OAC-440) — the shared ActionPicker wired to the tools
 * i18n namespace and the tools action-catalogue hook. */
export function ActionPicker(props: {
  value: PickerAction[];
  onChange: (next: PickerAction[]) => void;
  rowAction?: (action: PickerAction) => React.ReactNode;
  /** Read-only while a link change awaits a second administrator. */
  locked?: boolean;
  /** Ids the pending proposal would add, marked inline. */
  newIds?: ReadonlySet<string>;
}) {
  return (
    <SharedActionPicker {...props} ns="tools" useCatalog={useToolActionCatalog} />
  );
}
